import { AnyAction } from '@reduxjs/toolkit'

import {
  FETCH_GROUP_MEMBERS_SUCCESS,
  FETCH_GROUP_SUCCESS,
  RESET_GROUP_MEMBERS_PAGINATION_STATE,
  SET_FILTER_GROUP_MEMBER,
  SET_GROUP_MEMBERS_SORTING_STATE
} from './actionTypes'

type OrganizationGroupsMembersPageState = {
  page?: string[]
  group?: unknown
  totalUsers?: number
  startIndex?: number
  sortingColumn?: unknown
  filter?: string
}

export const initialState: OrganizationGroupsMembersPageState = {}

export default (state = initialState, action: AnyAction): OrganizationGroupsMembersPageState => {
  switch (action.type) {
    case FETCH_GROUP_SUCCESS: {
      return { ...state, group: action.response }
    }
    case FETCH_GROUP_MEMBERS_SUCCESS: {
      return {
        ...state,
        page: action.response.resources.map(({ id }: { id: string }) => id),
        totalUsers: action.response.totalResults,
        startIndex: action.response.startIndex
      }
    }

    case SET_GROUP_MEMBERS_SORTING_STATE: {
      return { ...state, sortingColumn: action.sortingColumn }
    }

    case SET_FILTER_GROUP_MEMBER: {
      return { ...state, filter: action.filter }
    }

    case RESET_GROUP_MEMBERS_PAGINATION_STATE: {
      return {
        ...state,
        sortingColumn: null,
        startIndex: 1,
        totalUsers: 0,
        page: [],
        filter: ''
      }
    }

    default: {
      return state
    }
  }
}
